import type { DataGridCheckRow } from '../../DataGrid/CheckCell/CheckCell';

import { useTranslation } from 'react-i18next';

import { getTestProps } from '../../../lib/helpers';

import { DuplicateSolidIcon } from '../../../images/shapes';

import PopoverItem from '../../Popover/PopoverItem/PopoverItem';

interface DuplicateSelectedButtonProps {
  /**
   * Array of checked rows
   */
  checkedRows: DataGridCheckRow[];
  /**
   * Is limit reach
   */
  limitReached?: string;
  /**
   * If action is disallowed
   */
  actionDisallowed?: boolean;
  /**
   * Handle duplicate button click, if not provided, duplicate button will navigate to duplicate page
   */
  onClick: (id: DataGridCheckRow) => void;
  /**
   * Test id
   */
  testId?: string;
}

const DuplicateSelectedButton = ({
  checkedRows,
  limitReached,
  actionDisallowed,
  onClick,
  testId,
}: DuplicateSelectedButtonProps) => {
  const { t } = useTranslation();
  return (
    <PopoverItem
      buttonColor="borderless"
      iconPosition="start"
      label={t('Global.Duplicate')}
      iconImage={
        <DuplicateSolidIcon className="w-3 text-blue dark:text-slate-200" />
      }
      color="blue"
      disabled={!!limitReached || actionDisallowed}
      tooltip={actionDisallowed ? t('UserRoles.CannotPerformAction') : ''}
      onClick={() => onClick(checkedRows[0])}
      {...getTestProps(testId, 'duplicate-data', 'testId')}
    />
  );
};

export default DuplicateSelectedButton;
